export const minLength = (nbMin: number) => new RegExp(`^.{${nbMin},}$`);
export const hasNumber = /^(?=.*[0-9]).+$/;
export const hasNotNumber = /^(?!.*[0-9]).+$/;
export const hasUppercaseLetter = /^(?=.*[A-Z]).+$/;
export const hasLowercaseLetter = /^(?=.*[a-z]).+$/;
export const hasSpecialCharacter = /^(?=.*\W).+$/;
export const emailValid = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
export const hashtagRegex = /#([^#^@^\s(?!\-:&/.)]+)[\s,;]*/g;
export const mentionRegex = /\B@\w+/g;
export const hashtagMentionsRegex =
    /(@\[([^\]]+)\]\[([^\]]+)\])|(@\[([^\]]+)\]\(([^)]+)\))|(#[^#\s,;:.]+)|(^|\s)(@[a-zA-Z0-9_\.]+\b)(?!;)/mu;
export const hashtagsRegex = /((#[a-zA-Z0-9_]+\b)(?!;))/m;
export const instagramUsernameRegex = /^[a-zA-Z0-9](?!.*[._]{2})[a-zA-Z0-9._]{0,28}[a-zA-Z0-9]$/;
